import React from 'react'
import { IDevice } from '@getgreenline/homi-shared'
import './deviceConfiguration.scss'

interface Props {
  device: IDevice
  showResetPasswordModal: (device: IDevice) => void
  showTerminalOptionsModal: (device: IDevice) => void
  showMonerisOptionsModal: (device: IDevice) => void
}

export const DeviceConfiguration = (props: Props) => {
  const { device, showResetPasswordModal, showTerminalOptionsModal, showMonerisOptionsModal } =
    props

  return (
    <div className='card device-card'>
      <header className='card-header device-card-header'>
        <h6 className='device-title'>{device.deviceId}</h6>
      </header>

      <main className='card-body device-card-body'>
        <div>
          <i className='fa fa-key mr-2' aria-hidden='true' />
          <a onClick={() => showResetPasswordModal(device)}>Change password</a>
        </div>
      </main>

      <footer className='card-footer device-card-footer bg-transparent'>
        <small>Payment settings</small>
        <div>
          <i className='fa fa-credit-card mr-2' aria-hidden='true' />
          <a onClick={() => showTerminalOptionsModal(device)}>Merrco</a>
        </div>

        <div>
          <i className='fa fa-credit-card mr-2' aria-hidden='true' />
          <a onClick={() => showMonerisOptionsModal(device)}>Moneris</a>
        </div>
      </footer>
    </div>
  )
}
